<template>
  <section class="counter-section section-padding pt-60 pb-50" :style="`background-color: var(--c-${vars.backgroundColor})`">
    <div id="process-3" class="process-section section-padding pt-0 pb-0">
    <div class="container">
      <div class="row">
        <div class="col-xl-4 col-lg-4">
          <div class="section-title">
            <h2>{{ vars.titleText }}</h2>
          </div>
        </div>
        <div class="col-xl-8 col-lg-8">
          <div class="row mt-40">
            <div
              v-for="(item, index) in items"
              :key="index"
              class="col-xl-6 col-lg-6 col-md-6 wow fadeInUp animated"
              :data-wow-delay="item.delay"
            >
              <div class="single-process-wrap">
                <div class="process-numm">
                  <span>{{ item.number }}</span>
                </div>
                <h4>{{ item.title }}</h4>
                <p>{{ item.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'CountSection',
  mixins: [ComponentMixin],

  data() {
    return {
      observers: [] as IntersectionObserver[],
      animatedElements: new Set(),
    };
  },

  computed: {
    items() {
      return this.groupedVariables.items;
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.setupIntersectionObservers();
    });
  },

  beforeUnmount() {
    this.observers.forEach((observer) => observer.disconnect());
  },

  methods: {
    setupIntersectionObservers() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };

      const elements = this.$refs.countElements;
      if (!elements) return;

      (elements as Element[]).forEach((element, index) => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.animatedElements.has(index)) {
              this.updateCount(index);
              this.animatedElements.add(index);
              observer.unobserve(entry.target);
            }
          });
        }, options);

        observer.observe(element);
        this.observers.push(observer);
      });
    },

    updateCount(index: number) {
      const count = this.counts[index];
      const element = this.$el.querySelectorAll('.odometer')[index];
      if (element) {
        this.animateValue(element, 0, parseInt(count.title, 10), 2000, count.prefix || '', count.suffix || '');
      }
    },

    animateValue(element: HTMLElement, start: number, end: number, duration: number, prefix = '', suffix = '') {
      let startTime: number | null = null;

      const easeOutQuad = (t: number) => {
        return t * (2 - t);
      };

      const step = (timestamp: number) => {
        if (!startTime) {
          startTime = timestamp;
        }
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easeOutQuad(progress);

        const currentValue = Math.floor(easedProgress * (end - start) + start).toLocaleString();

        element.innerText = `${prefix}${currentValue}${suffix}`;

        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };

      window.requestAnimationFrame(step);
    },
  },
});
</script>
<style scoped>
.process-numm {
              position: absolute;
        top: -160px;
        left: -5px;
    
            
            span {
            font-size: 160px;
            font-weight: 600;
            color: #f0f0f0;
        }
        }
</style>